import { InterpretationsT3Component } from './../interpretations-t3/interpretations-t3.component';
import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { SelfAssessmentTemplate3OverallAssessmentComponent } from '../self-assessment-template3-overall-assessment/self-assessment-template3-overall-assessment.component';
import { JudgmentT3Component } from '../judgment-t3/judgment-t3.component';
import { ApproachT3Component } from '../approach-t3/approach-t3.component';
import * as signalR from '@microsoft/signalr';
import { SignalRService } from 'src/app/core/services/signalR/signal-r.service';
import {
  LoggedUserItem,
  ckEditorBroadcastMessage,
} from 'src/app/core/models/signalR/ckEditorBroadcastMessage';
import { UserProfile } from 'src/app/core/models/user';
import { ActivatedRoute, NavigationExtras, NavigationStart, Router } from '@angular/router';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { SelfassementSummary } from 'src/app/core/models/self-assessmentT3/SelfassessmentSummary';
import { MatDialog } from '@angular/material/dialog';
import { TimePickerComponent } from '../../shared/time-picker/time-picker.component';
import { TimeSpentModel } from 'src/app/core/models/self-assessment/timespent-model';
import { AlertDialogModel } from 'src/app/core/models/view-model';
import { DeleteDialogComponent } from '../../distributed-ui-components';

@Component({
  selector: 'app-self-assessment-details',
  templateUrl: './self-assessment-details.component.html',
  styleUrls: ['./self-assessment-details.component.scss'],
})
export class SelfAssessmentDetailsComponent implements OnInit {
  fixedBar: boolean = false;
  @ViewChild(SelfAssessmentTemplate3OverallAssessmentComponent)
  overAllAsmnt!: SelfAssessmentTemplate3OverallAssessmentComponent;
  @ViewChild(InterpretationsT3Component)
  interetation!: InterpretationsT3Component;
  @ViewChild(JudgmentT3Component)
  judgement!: JudgmentT3Component;
  @ViewChild(ApproachT3Component)
  appproach!: ApproachT3Component;
  activatedTab: number = 0;
  activatedTabIndex: number = 0;
  @Input() selfAssessmentId: number = 0;
  private _hubConnection!: signalR.HubConnection;
  locationName: string = '';
  user: UserProfile;
  logedInUserList: LoggedUserItem[] = [];
  selftassessmentSummary: SelfassementSummary;
  alertDialogModel: AlertDialogModel;

  @ViewChild(SelfAssessmentTemplate3OverallAssessmentComponent) selfAssessmentTemplate3OverallAssessmentComponent!: SelfAssessmentTemplate3OverallAssessmentComponent;
  @ViewChild(InterpretationsT3Component) interpretationsT3Component!: InterpretationsT3Component;
  @ViewChild(JudgmentT3Component) judgmentT3Component!: JudgmentT3Component;
  @ViewChild(ApproachT3Component) approachT3Component!: ApproachT3Component;
  idList: number[]=[];
  constructor(
    private signalRService: SignalRService,
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private sessionService: SessionService,
    private selfAssessment3Service: SelfAssessmentTemplate3Service,
    public dialog: MatDialog,
    private router: Router
  ) {
    this.user = new UserProfile();
    this.alertDialogModel = new AlertDialogModel();
    this.selftassessmentSummary = new SelfassementSummary();
    route.params.subscribe((params: any) => {
      this.selfAssessmentId = params['id'];
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.onNavigationStart();
      }
    });
    this.route.paramMap.subscribe(params => {
      const state = window.history.state;
      if (state && state.idList) {
        this.idList = state.idList;
      } else {
        this.idList = [];
      }
    });
  }
  ngOnInit() {
    this.getUserProfile();
    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl('https://' + window.location.host + '/notify')
      .build();
    this._hubConnection
      .start()
      .then(() => {})
      .catch((err: any) => {});
    this._hubConnection.on(
      'BroadcastSAT3Message',
      (message: ckEditorBroadcastMessage) => {
        if (
          this.selfAssessmentId == message.selfAssessmentId &&
          this.user.externalUserId != message.userId
        ) {
          //alert( "ckeditor is updated by others, please reload it");
          alert(
            'Editors are updated by ' +
              message.userName +
              ', please reload the page, otherwise you will lose the updated information'
          );
        }
      }
    );
    this._hubConnection.on(
      'BroadcastSAT3JoinPage',
      (message: ckEditorBroadcastMessage) => {
        if (this.locationName == message.url) {
          let userArray: any[] = JSON.parse(message.loggedInUsers);
          this.logedInUserList = userArray.filter(
            (item) => item.UserId !== this.user.externalUserId
          );
          this.logedInUserList.sort((a, b) =>
            a.userName.localeCompare(b.userName)
          );
          this.ref.detectChanges();
        }
      }
    );
    this._hubConnection.on(
      'BroadcastSAT3LeavePage',
      (message: ckEditorBroadcastMessage) => {
        if (this.locationName == message.url) {
          let userArray: any[] = JSON.parse(message.loggedInUsers);
          this.logedInUserList = userArray.filter(
            (item) => item.UserId !== this.user.externalUserId
          );
          this.logedInUserList.sort((a, b) =>
            a.userName.localeCompare(b.userName)
          );
          this.ref.detectChanges();
        }
      }
    );
    this.getSelfassessmentSummary();
  }

  @HostListener('window:scroll', ['$event']) onScroll() {
    if (window.scrollY > 100) {
      this.fixedBar = true;
    } else {
      this.fixedBar = false;
    }
  }

  tab: string[] = [
    'Summary',
    'Key Information',
    'Overall Assessment',
    'Interpretations',
    'Judgements',
    'Approaches',
  ];
  tabChange(tabIndex: number) {
    this.activatedTabIndex = tabIndex;
  }
  setTab(index: number) {
    let isChanges;
    if(this.activatedTabIndex==2){
       isChanges=this.selfAssessmentTemplate3OverallAssessmentComponent.performLeaveCheck();
    }
    else if(this.activatedTabIndex==3){
       isChanges=this.interpretationsT3Component.performLeaveCheck();
    }
    else if(this.activatedTabIndex==4){
      isChanges=this.judgmentT3Component.performLeaveCheck();
    }
    else if(this.activatedTabIndex==5){
      isChanges=this.approachT3Component.performLeaveCheck();
    }
    if(isChanges!=true){
      this.activatedTab = index;
      this.activatedTabIndex = index;
    }
    else{
      this.alertDialogModel.HeadingText = 'Warning';
      this.alertDialogModel.BodyText = 'Are you sure you want to exit this tab? Unsaved data will be lost.';
      this.alertDialogModel.ActionButtonText = 'Confirm';
      this.alertDialogModel.IsAction = true;

      const dialogRef = this.dialog.open(DeleteDialogComponent, {
        width: '450px',
        data: this.alertDialogModel
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'Warning') {
          this.activatedTab = index;
          this.activatedTabIndex = index;
        }
      })
      }

  }
  saveAllT3AssessmentData() {
    switch (this.activatedTabIndex) {
      case 0:
        break;
      case 1:
        break;
      case 2:
        this.overAllAsmnt.saveOverAllAssessment();
        break;
      case 3:
        this.interetation.saveInterpretationData();
        break;
      case 4:
        this.judgement.savejudgement();
        break;
      case 5:
        this.appproach.saveApproachData();
        break;
    }
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      if (window.location.pathname == '/library/rule-book') {
        this.locationName =
          '/self-assessment/details/self/3/' + this.selfAssessmentId;
      } else {
        this.locationName = window.location.pathname;
      }
      this.onJoiningPage();
    });
  }
  async onJoiningPage() {
    let boradcastMessage = new ckEditorBroadcastMessage();
    boradcastMessage.selfAssessmentId = this.selfAssessmentId;
    boradcastMessage.userId = this.user.externalUserId;
    boradcastMessage.userName = this.user.fullName;
    boradcastMessage.url = this.locationName;
    this.signalRService
      .JoinSelfAssessmentT3Page(boradcastMessage)
      .subscribe((result: any) => {});
  }
  async onLeavingPage() {
    let boradcastMessage = new ckEditorBroadcastMessage();
    boradcastMessage.selfAssessmentId = this.selfAssessmentId;
    boradcastMessage.userId = this.user.externalUserId;
    boradcastMessage.userName = this.user.fullName;
    boradcastMessage.url = this.locationName;
    this.signalRService
      .LeaveSelfAssessmentT3Page(boradcastMessage)
      .subscribe((result: any) => {});
  }
  @HostListener('window:beforeunload', ['$event'])
  unloadHandler($event: any): void {
    this.onLeavingPage();
    // Make API call before leaving the page
  }
  onNavigationStart() {
    // Your logic when navigation starts (e.g., clicking on a navbar link)
    this.onLeavingPage();
  }
  onNotifyCkeditorChange() {
    this.broadCastMessageOnEditorSave();
  }
  broadCastMessageOnEditorSave() {
    let boradcastMessage = new ckEditorBroadcastMessage();
    boradcastMessage.selfAssessmentId = this.selfAssessmentId;
    boradcastMessage.userId = this.user.externalUserId;
    boradcastMessage.userName = this.user.fullName;
    this.signalRService
      .broadcastT3Message(boradcastMessage)
      .subscribe((result: any) => {});
  }
  getSelfassessmentSummary() {
    this.selfAssessment3Service
      .getT3SummaryAssessment(this.selfAssessmentId)
      .subscribe((data: any) => {
        this.selftassessmentSummary = data;
      });
  }
  updateRecordTime() {
    this.selftassessmentSummary.isRecordTime =
      !this.selftassessmentSummary.isRecordTime;
    let timeSpentModel = new TimeSpentModel();
    if (this.selftassessmentSummary.isRecordTime) {
      const dialogRef = this.dialog.open(TimePickerComponent, {
        width: '330px',
        panelClass: 'custom-time-modal',
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          timeSpentModel.timeSpent = result;
          timeSpentModel.isRecordTime = true;
          timeSpentModel.id = this.selftassessmentSummary.id;
          this.selfAssessment3Service
            .updateTimeSpent(timeSpentModel)
            .subscribe((res) => {
              this.getSelfassessmentSummary();
              this.ref.detectChanges();
            });
        }
      });
    } else {
      timeSpentModel.timeSpent = 0;
      timeSpentModel.isRecordTime = false;
      timeSpentModel.id = this.selftassessmentSummary.id;
      this.selfAssessment3Service
        .updateTimeSpent(timeSpentModel)
        .subscribe((res) => {
          this.getSelfassessmentSummary();
          this.ref.detectChanges();
        });
    }
  }
  sendNotification() {
    this.selftassessmentSummary.isSendNotification =
      !this.selftassessmentSummary.isSendNotification;
    this.selfAssessment3Service
      .getT3SummarySendNotification(
        this.selftassessmentSummary.isSendNotification,
        this.selfAssessmentId
      )
      .subscribe((data: boolean) => {});
  }
  //previous next button add
  checkSibling(id: number, type: string): boolean {
    const index = this.idList.findIndex((a) => Number(a)=== Number(id));
    if (index < 0) {
      return false;
    } else {
      if (type === 'Next') {
        return this.idList[index + 1] ? true : false;
      } else {
        return this.idList[index - 1] ? true : false;
      }
    }
  }
  getSiblings(type: string): void {
    const index = this.idList.findIndex(
      (a) => Number(a) === Number(this.selfAssessmentId));
    if (type === 'Next') {
      this.selfAssessmentId = this.idList[index + 1];
    } else {
      this.selfAssessmentId = this.idList[index - 1];
    }
    this.redirectLink();
  }
  redirectLink() {
    let link = '/self-assessment/details/self/3/' + this.selfAssessmentId + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
   this.router.navigate([link], navigationExtras);
  }
}
